import React from 'react';
import PropTypes from 'prop-types';
import { Box, Button, IconButton } from '@mui/material';
import { KeyboardArrowDown } from '@mui/icons-material';
import MenuIcon from '@mui/icons-material/Menu';
import { LoggedInUserPropType } from '@src/components/prop-types/user';

export const UserMenuButton = ({ user, toggleMenu, loginUrl }) => {
    return (
        <>
            <Box sx={{ display: { xs: 'flex', desktop: 'none' } }}>
                <IconButton
                    onClick={toggleMenu}
                    sx={{ height: '32px', width: '32px', p: 0.5 }}
                    disableRipple
                    id='user-menu-mobile'
                >
                    <MenuIcon sx={{ fontSize: 28, color: '#fff' }} />
                </IconButton>
            </Box>
            <Button
                id='user-menu-button'
                onClick={user && !user.Guest ? toggleMenu : null}
                href={user && !user.Guest ? undefined : loginUrl}
                sx={{
                    color: 'white',
                    alignItems: 'center',
                    fontWeight: user ? 500 : 700,
                    fontSize: '14px',
                    display: { xs: 'none', desktop: 'flex' },
                    gap: '6px',
                    padding: 0,
                    textTransform: user ? 'none' : 'uppercase',
                    textDecoration: 'none',
                    '&:hover': {
                        backgroundColor: 'transparent',
                        color: 'white'
                    },
                    '&:focus': {
                        outline: 'none',
                        color: 'white'
                    },
                    '&:focus-visible': {
                        outline: '2px solid white',
                        color: 'white'
                    }
                }}
                disableRipple
            >
                {user && !user.Guest ? (
                    <>
                        <Box
                            sx={{
                                fontSize: '14px',
                                lineHeight: '19px',
                                maxWidth: '110px',
                                overflow: 'd-none',
                                whiteSpace: 'nowrap',
                                textOverflow: 'ellipsis'
                            }}
                        >
                            Hello, {user.DisplayName}
                        </Box>
                        <KeyboardArrowDown size={23} />
                    </>
                ) : (
                    'REGISTER/SIGN IN'
                )}
            </Button>
        </>
    );
};

UserMenuButton.propTypes = {
    user: LoggedInUserPropType,
    toggleMenu: PropTypes.func.isRequired,
    loginUrl: PropTypes.string.isRequired
};
